import React from 'react';

const LandingPage = () => {
  return (
    <div className="bg-offwhite text-charcoal font-sans min-h-screen">
      {/* Navigation */}
      <nav className="bg-navy text-white p-6 sticky top-0 z-50 shadow-lg">
        <div className="container mx-auto flex justify-between items-center">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-silver rounded-sm transform rotate-45 flex items-center justify-center">
              <span className="text-navy font-bold transform -rotate-45">O</span>
            </div>
            <span className="text-2xl font-serif font-bold tracking-wider">ORNAMINT</span>
          </div>
          <div className="hidden md:flex space-x-8 text-sm font-medium uppercase tracking-widest">
            <a href="#about" className="hover:text-silver transition-colors">Arbitrage</a>
            <a href="#packages" className="hover:text-silver transition-colors">Packages</a>
            <a href="#compliance" className="hover:text-silver transition-colors">Safety</a>
            <a href="#referral" className="hover:text-silver transition-colors">Referral</a>
          </div>
          <a href="https://user.ornamint.world" className="bg-silver text-navy px-6 py-2 rounded-full font-bold hover:bg-white transition-all transform hover:scale-105">
            LOGIN
          </a>
        </div>
      </nav>

      {/* Hero Section */}
      <header className="relative bg-navy text-white py-24 overflow-hidden">
        <div className="absolute inset-0 opacity-20 bg-[url('https://images.unsplash.com/photo-1554118811-1e0d58224f24?auto=format&fit=crop&q=80&w=2000')] bg-cover bg-center"></div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-3xl">
            <h1 className="text-5xl md:text-7xl font-serif font-bold mb-6 leading-tight uppercase">
              ORNAMINT: <span className="text-silver italic">Strategic Silver Arbitrage</span> & Partner Architecture
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-gray-300 leading-relaxed">
              A deep dive into asset-backed returns powered by global trade efficiency and a structured commission ecosystem.
            </p>
            <div className="flex flex-wrap gap-4 mb-10">
              <span className="bg-silver/20 border border-silver/30 px-4 py-1 rounded-full text-xs font-bold tracking-widest uppercase">Asset-Backed</span>
              <span className="bg-silver/20 border border-silver/30 px-4 py-1 rounded-full text-xs font-bold tracking-widest uppercase">Fully Compliant</span>
              <span className="bg-silver/20 border border-silver/30 px-4 py-1 rounded-full text-xs font-bold tracking-widest uppercase">Institutional Grade</span>
            </div>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <a href="https://user.ornamint.world" className="bg-silver text-navy px-10 py-4 rounded-md font-bold text-center hover:bg-white transition-all shadow-xl">
                START ARBITRAGE
              </a>
              <a href="#about" className="border border-silver text-silver px-10 py-4 rounded-md font-bold text-center hover:bg-silver hover:text-navy transition-all">
                HOW IT WORKS
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Stats Bar */}
      <div className="bg-white py-12 shadow-md relative z-20 -mt-10 mx-6 rounded-xl border border-gray-100">
        <div className="container mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 px-6">
          <div className="text-center">
            <p className="text-3xl font-bold text-navy">99.99</p>
            <p className="text-sm text-gray-500 uppercase tracking-widest">Fine Silver</p>
          </div>
          <div className="text-center">
            <p className="text-3xl font-bold text-navy">10-30</p>
            <p className="text-sm text-gray-500 uppercase tracking-widest">Day Cycles</p>
          </div>
          <div className="text-center">
            <p className="text-3xl font-bold text-navy">4-5%</p>
            <p className="text-sm text-gray-500 uppercase tracking-widest">Monthly ROI</p>
          </div>
          <div className="text-center">
            <p className="text-3xl font-bold text-navy">100%</p>
            <p className="text-sm text-gray-500 uppercase tracking-widest">Asset Backed</p>
          </div>
        </div>
      </div>

      <section id="about" className="py-24 container mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-start gap-16">
          <div className="lg:w-1/2">
            <h2 className="text-4xl font-serif font-bold mb-8 text-navy uppercase tracking-tight">🌍 Arbitrage Engine <span className="text-silver font-normal block text-xl mt-2">(Thailand → India)</span></h2>
            <div className="space-y-8">
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-12 h-12 bg-silver rounded-full flex items-center justify-center font-bold text-navy shadow-inner">1</div>
                <div>
                  <h3 className="text-xl font-bold mb-2 uppercase tracking-tight">Source</h3>
                  <p className="text-gray-600 leading-relaxed">International market-linked pricing from Thailand, ensuring competitive acquisition rates.</p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-12 h-12 bg-silver rounded-full flex items-center justify-center font-bold text-navy shadow-inner">2</div>
                <div>
                  <h3 className="text-xl font-bold mb-2 uppercase tracking-tight">Logistics</h3>
                  <p className="text-gray-600 leading-relaxed">Secured and bonded transportation through regulated free trade zones.</p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-12 h-12 bg-silver rounded-full flex items-center justify-center font-bold text-navy shadow-inner">3</div>
                <div>
                  <h3 className="text-xl font-bold mb-2 uppercase tracking-tight">Import</h3>
                  <p className="text-gray-600 leading-relaxed">Streamlined Indian customs clearance under official bullion classification standards.</p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-12 h-12 bg-silver rounded-full flex items-center justify-center font-bold text-navy shadow-inner">4</div>
                <div>
                  <h3 className="text-xl font-bold mb-2 uppercase tracking-tight">Monetize</h3>
                  <p className="text-gray-600 leading-relaxed">Distribution into high-liquidity domestic bullion markets for optimized returns.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="lg:w-1/2 w-full">
            <div className="bg-navy text-white p-8 md:p-12 rounded-3xl shadow-2xl relative overflow-hidden">
              <div className="absolute top-0 right-0 p-8 opacity-10">
                <svg width="120" height="120" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
                </svg>
              </div>
              <h3 className="text-2xl font-serif font-bold mb-8 border-b border-silver/30 pb-4">Key Highlights</h3>
              <div className="space-y-6">
                <div>
                  <p className="text-silver text-xs uppercase tracking-widest mb-1">Asset</p>
                  <p className="text-xl font-bold">99.99 Fine Silver Bullion (1kg bars)</p>
                </div>
                <div>
                  <p className="text-silver text-xs uppercase tracking-widest mb-1">Opportunity</p>
                  <p className="text-xl font-bold">Capture price differences across global markets</p>
                </div>
                <div>
                  <p className="text-silver text-xs uppercase tracking-widest mb-1">Cycle Speed</p>
                  <p className="text-xl font-bold">10–30 day trade cycles</p>
                  <p className="text-sm text-gray-400 mt-1 italic">Enabling rapid capital rotation</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="packages" className="bg-navy py-24 text-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-serif font-bold mb-4 uppercase tracking-widest">💼 Capital Deployment & Returns</h2>
            <p className="text-silver max-w-2xl mx-auto uppercase tracking-widest text-sm font-medium">Transparent returns with institutional-grade security</p>
          </div>
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-20">
            <div className="bg-white text-navy p-10 rounded-2xl shadow-xl hover:shadow-2xl transition-all border-t-8 border-silver">
              <h3 className="text-2xl font-serif font-bold mb-2 uppercase tracking-tight">Package 1</h3>
              <p className="text-gray-400 mb-8 font-medium">$500 – $4,500 Deployment</p>
              <div className="text-6xl font-bold mb-8 text-navy">4% <span className="text-sm font-normal text-gray-500 block">Monthly ROI</span></div>
              <a href="https://user.ornamint.world" className="block w-full py-4 text-center rounded-md bg-navy text-white font-bold hover:bg-charcoal transition-colors uppercase tracking-widest text-sm">Deploy Now</a>
            </div>
            <div className="bg-white text-navy p-10 rounded-2xl shadow-xl hover:shadow-2xl transition-all border-t-8 border-silver transform md:scale-105 z-10">
              <div className="bg-navy text-white text-[10px] py-1 px-3 rounded-full inline-block mb-4 font-bold tracking-widest uppercase">Institutional</div>
              <h3 className="text-2xl font-serif font-bold mb-2 uppercase tracking-tight">Package 2</h3>
              <p className="text-gray-400 mb-8 font-medium">$5,000+ Deployment</p>
              <div className="text-6xl font-bold mb-8 text-navy">5% <span className="text-sm font-normal text-gray-500 block">Monthly ROI</span></div>
              <a href="https://user.ornamint.world" className="block w-full py-4 text-center rounded-md bg-silver text-navy font-bold hover:bg-navy hover:text-white transition-all uppercase tracking-widest text-sm">Deploy Now</a>
            </div>
          </div>

          <div className="max-w-4xl mx-auto bg-white/5 backdrop-blur-sm border border-white/10 p-8 md:p-12 rounded-3xl">
            <h3 className="text-2xl font-serif font-bold mb-8 text-center uppercase tracking-widest border-b border-white/10 pb-6">Unmatched Flexibility</h3>
            <div className="grid sm:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-12 h-12 bg-silver/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-silver font-bold">0</span>
                </div>
                <h4 className="font-bold mb-2 uppercase text-xs tracking-widest">Zero Fees</h4>
                <p className="text-sm text-gray-400">Withdraw your capital anytime with zero fees</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-silver/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-silver font-bold">∞</span>
                </div>
                <h4 className="font-bold mb-2 uppercase text-xs tracking-widest">Full Access</h4>
                <p className="text-sm text-gray-400">Full, penalty-free withdrawals of any size</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-silver/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-silver font-bold">✓</span>
                </div>
                <h4 className="font-bold mb-2 uppercase text-xs tracking-widest">No Limits</h4>
                <p className="text-sm text-gray-400">No limitations or restrictions — complete flexibility</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="referral" className="py-24 container mx-auto px-6">
        <div className="bg-white border border-gray-100 rounded-[3rem] p-8 md:p-16 shadow-2xl overflow-hidden relative">
          <div className="absolute top-0 right-0 w-64 h-64 bg-silver/5 rounded-full -mr-32 -mt-32"></div>
          <div className="relative z-10">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-16 gap-8">
              <div className="max-w-2xl">
                <h2 className="text-4xl font-serif font-bold mb-6 text-navy uppercase tracking-widest">🤝 Partner Architecture</h2>
                <p className="text-lg text-gray-600 leading-relaxed">
                  Our comprehensive 15-level reward structure distributes a total of <span className="text-navy font-bold">83% ROI</span> back to our community partners, powered by global silver trade efficiency.
                </p>
              </div>
              <div className="bg-navy text-white px-8 py-6 rounded-2xl text-center">
                <span className="block text-xs uppercase tracking-[0.2em] mb-2 opacity-60">Total Distribution</span>
                <span className="text-4xl font-bold font-serif italic text-silver">83% ROI</span>
              </div>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
              {[
                { level: 1, comm: '20%' },
                { level: 2, comm: '10%' },
                { level: 3, comm: '9%' },
                { level: 4, comm: '8%' },
                { level: 5, comm: '7%' },
                { level: 6, comm: '6%' },
                { level: 7, comm: '4%' },
                { level: 8, comm: '3%' },
                { level: 9, comm: '3%' },
                { level: 10, comm: '3%' },
                { level: 11, comm: '2%' },
                { level: 12, comm: '2%' },
                { level: 13, comm: '2%' },
                { level: 14, comm: '2%' },
                { level: 15, comm: '2%' },
              ].map((item) => (
                <div key={item.level} className="bg-offwhite p-6 rounded-xl border border-gray-100 hover:border-silver transition-colors group">
                  <span className="block text-[10px] text-gray-400 mb-1 uppercase tracking-widest font-bold">Level {item.level}</span>
                  <span className="text-2xl font-bold text-navy group-hover:text-silver transition-colors">{item.comm}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Safety & Risk Sections */}
      <section id="compliance" className="py-24 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16">
            {/* Investor Safety & Compliance Protocol */}
            <div>
              <h2 className="text-4xl font-serif font-bold mb-10 text-navy uppercase tracking-tight">🔐 Investor Safety & Compliance</h2>
              <div className="space-y-8">
                <div className="bg-offwhite p-8 rounded-2xl border border-gray-100">
                  <h4 className="font-bold text-navy mb-4 text-xl uppercase tracking-tighter">1. Official Channels Only</h4>
                  <ul className="text-sm text-gray-600 space-y-2">
                    <li className="flex gap-2"><span>•</span> All investments must go to official company bank accounts</li>
                    <li className="flex gap-2"><span>•</span> Accounts are listed on the official website</li>
                    <li className="flex gap-2"><span>•</span> Prevents fraud / unauthorized collections</li>
                  </ul>
                </div>
                {/* <div className="bg-red-50/30 p-8 rounded-2xl border border-red-100">
                  <h4 className="font-bold text-red-900 mb-4 text-xl uppercase tracking-tighter">2. Zero Tolerance Policy</h4>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    <div className="bg-white p-3 rounded-lg text-center border border-red-100 shadow-sm">
                      <span className="block text-xl mb-1">❌</span>
                      <span className="text-[10px] font-bold text-red-800 uppercase">No Cash</span>
                    </div>
                    <div className="bg-white p-3 rounded-lg text-center border border-red-100 shadow-sm">
                      <span className="block text-xl mb-1">❌</span>
                      <span className="text-[10px] font-bold text-red-800 uppercase">No 3rd Party</span>
                    </div>
                    <div className="bg-white p-3 rounded-lg text-center border border-red-100 shadow-sm">
                      <span className="block text-xl mb-1">❌</span>
                      <span className="text-[10px] font-bold text-red-800 uppercase">No Agents</span>
                    </div>
                  </div>
                  <p className="mt-4 text-xs font-bold text-red-700 uppercase text-center tracking-widest">Ensures full financial transparency</p>
                </div> */}
                {/* <div className="bg-offwhite p-8 rounded-2xl border border-gray-100">
                  <h4 className="font-bold text-navy mb-4 text-xl uppercase tracking-tighter">3. Mandatory KYC</h4>
                  <p className="text-sm text-gray-600 leading-relaxed">Identity verification required before investment. Ensures legal compliance & investor authenticity.</p>
                </div> */}
              </div>
            </div>

            {/* Risk Mitigation Strategy */}
            <div>
              <h2 className="text-4xl font-serif font-bold mb-10 text-navy uppercase tracking-tight">🛡️ Risk Mitigation Strategy</h2>
              <div className="space-y-8">
                <div className="flex gap-6">
                  <div className="w-16 h-16 bg-silver/20 rounded-2xl flex-shrink-0 flex items-center justify-center text-2xl">📦</div>
                  <div>
                    <h4 className="font-bold text-navy mb-2 text-xl">Physical Backing</h4>
                    <p className="text-sm text-gray-600">Trades are backed by 99.99 fine silver bullion. No paper trading / derivatives. Real asset-based investment.</p>
                  </div>
                </div>
                <div className="flex gap-6">
                  <div className="w-16 h-16 bg-silver/20 rounded-2xl flex-shrink-0 flex items-center justify-center text-2xl">⏱️</div>
                  <div>
                    <h4 className="font-bold text-navy mb-2 text-xl">Short Trade Cycles</h4>
                    <p className="text-sm text-gray-600">Duration: 10–30 days. Benefits: Faster capital rotation and lower long-term risk exposure.</p>
                  </div>
                </div>
                <div className="flex gap-6">
                  <div className="w-16 h-16 bg-silver/20 rounded-2xl flex-shrink-0 flex items-center justify-center text-2xl">💧</div>
                  <div>
                    <h4 className="font-bold text-navy mb-2 text-xl">Liquidity</h4>
                    <p className="text-sm text-gray-600">Strong demand in Indian market (jewelers, manufacturers). Ensures easy exit (sell anytime).</p>
                  </div>
                </div>
                
                <div className="mt-12 p-8 bg-navy text-white rounded-[2rem] shadow-xl relative overflow-hidden">
                  <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/brushed-alum.png')]"></div>
                  <div className="relative z-10">
                    <p className="text-silver font-bold uppercase tracking-[0.3em] text-[10px] mb-4">Compliance Standard</p>
                    <p className="text-2xl font-serif italic mb-6">"Operating with institutional-grade transparency and asset-backed security."</p>
                    <div className="flex gap-4">
                      <span className="text-[10px] font-bold border border-white/20 px-3 py-1 rounded">GST READY</span>
                      {/* <span className="text-[10px] font-bold border border-white/20 px-3 py-1 rounded">KYC VERIFIED</span> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Capital Deployment Cycle */}
      <section className="py-24 bg-navy text-white overflow-hidden">
        <div className="container mx-auto px-6">
          <div className="text-center mb-20">
            <p className="text-silver font-bold uppercase tracking-[0.4em] text-xs mb-4">Core Concept</p>
            <h2 className="text-4xl md:text-5xl font-serif font-bold uppercase tracking-tight mb-6">
              "Trade execution, <span className="text-silver italic">not financial engineering</span>"
            </h2>
          </div>

          <div className="relative">
            {/* Connection Line (Desktop) */}
            <div className="hidden lg:block absolute top-1/2 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-silver/20 to-transparent -translate-y-1/2"></div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8 relative z-10">
              {[
                { title: 'Investor Capital', desc: 'Comes via bank transfer', icon: '💰' },
                { title: 'Sourcing', desc: 'Silver purchased from international markets', icon: '🏭' },
                { title: 'Logistics', desc: 'Stored in secure bonded/free zones', icon: '🚢' },
                { title: 'Clearance', desc: 'Handled via Indian Customs & GST', icon: '📋' },
                { title: 'Distribution', desc: 'Sold in domestic bullion market', icon: '🏪' },
                { title: 'Returns', desc: 'Profit generated & reinvested', icon: '🔄' },
              ].map((step, idx) => (
                <div key={idx} className="flex flex-col items-center text-center group">
                  <div className="w-20 h-20 bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl flex items-center justify-center text-3xl mb-6 group-hover:bg-silver group-hover:text-navy transition-all duration-500 shadow-xl group-hover:-translate-y-2">
                    {step.icon}
                  </div>
                  <h4 className="font-bold mb-2 uppercase tracking-tighter text-sm">{step.title}</h4>
                  <p className="text-xs text-gray-400 leading-relaxed max-w-[150px]">{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <footer className="bg-navy text-white py-16">
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center border-b border-gray-800 pb-12 mb-12">
            <div className="flex items-center space-x-2 mb-8 md:mb-0">
              <div className="w-10 h-10 bg-silver rounded-sm transform rotate-45 flex items-center justify-center">
                <span className="text-navy font-bold transform -rotate-45">O</span>
              </div>
              <span className="text-3xl font-serif font-bold tracking-wider">ORNAMINT</span>
            </div>
            <div className="flex flex-col items-center md:items-end">
              <p className="text-silver mb-2">Ready to deploy capital?</p>
              <a href="https://user.ornamint.world" className="text-2xl font-serif font-bold hover:text-silver transition-colors">ornamint.world</a>
            </div>
          </div>
          <div className="flex flex-col md:flex-row justify-between text-xs text-gray-500 uppercase tracking-widest gap-8">
            <div className="flex gap-8">
              <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
              <a href="#" className="hover:text-white transition-colors">Compliance</a>
            </div>
            <p>&copy; 2026 Ornamint Silver. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
